// TabContent1.js
import React, { useState } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import Subheading from '../../../../theme/text/Subheading';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import { ReactComponent as DhlLogo } from '../../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../../styles/svg/dpd.svg';
import { ReactComponent as PostNLLogo } from '../../../../../styles/svg/postnl.svg';
import { ReactComponent as BolLogo } from '../../../../../styles/svg/bol.svg';
import { ReactComponent as ParcelLogo } from '../../../../../styles/svg/parcel.svg';
import { ReactComponent as CirroLogo } from '../../../../../styles/svg/cirro.svg';
import { ReactComponent as SendcloudLogo } from '../../../../../styles/svg/sendcloud.svg';
import { ReactComponent as InnosendLogo } from '../../../../../styles/svg/innosend.svg';
import { ReactComponent as UpsLogo } from '../../../../../styles/svg/ups.svg';
import { ReactComponent as IntrapostLogo } from '../../../../../styles/svg/intrapost.svg';
import { ReactComponent as MyparcelLogo } from '../../../../../styles/svg/myparcel.svg';
import { ReactComponent as GlsLogo } from '../../../../../styles/svg/gls.svg';
import { ReactComponent as TrunkrsLogo } from '../../../../../styles/svg/trunkrs.svg';
import { ReactComponent as CycloonLogo } from '../../../../../styles/svg/cycloon.svg';
import { ReactComponent as MyparcelcomLogo } from '../../../../../styles/svg/myparcelcom.svg';
import { ReactComponent as HstLogo } from '../../../../../styles/svg/hst.svg';
import { ReactComponent as AmpereLogo } from '../../../../../styles/svg/ampere.svg';
import { ReactComponent as ZinepsLogo } from '../../../../../styles/svg/zineps.svg';
import { ReactComponent as VinologixLogo } from '../../../../../styles/svg/vinologix.svg';
import { ReactComponent as WegrowLogo } from '../../../../../styles/svg/wegrow.svg';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import { setProgressionInfo } from '../../../../../newapi/global/progressionTabSlice';
import { useDispatch } from 'react-redux';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    
    const dispatch = useDispatch();
    // if (props.title || props.subtitle || typeof props.maxSteps !== 'undefined') {
    //     dispatch(setProgressionInfo({ title: props.title, subtitle: props.subtitle, maxSteps: props.maxSteps }));
    //   }

    const columns = [
        {title: "PostNL", logo: <PostNLLogo width={60} height={60}/>, key: "postnl"},
        {title: "DHL", logo: <DhlLogo width={60} height={60}/>, key: "dhl"},
        {title: "Dpd", logo: <DpdLogo width={60} height={60}/>, key: "dpd"},
        // {title: "Bol.", logo: <BolLogo width={60} height={60}/>, key: "bol"}, // Bol.com is not a shipper, it's a webshop
        {title: "Parcel", logo: <ParcelLogo width={60} height={60}/>, key: "parcel"},
        {title: "Cirro", logo: <CirroLogo width={60} height={60}/>, key: "cirro"},
        {title: "Sendcloud", logo: <SendcloudLogo width={60} height={60}/>, key: "sendcloud"},
        {title: "Innosend", logo: <InnosendLogo width={60} height={60}/>, key: "innosend"},
        {title: "Innosend V2", logo: <InnosendLogo width={60} height={60}/>, key: "innosendv2"},
        {title: "UPS", logo: <UpsLogo width={60} height={60}/>, key: "ups"},
        {title: "DHL Germany", logo: <DhlGermanyLogo width={60} height={60}/>, key: "dhlgermany"},
        {title: "Intrapost", logo: <IntrapostLogo width={60} height={60}/>, key: "intrapost"},
        {title: "MyParcel", logo: <MyparcelLogo width={60} height={60}/>, key: "myparcel"},
        {title: "MyParcel.com", logo: <MyparcelcomLogo width={60} height={60}/>, key: "myparcelcom"},
        {title: "GLS", logo: <GlsLogo width={120} height={120}/>, key: "gls"},
        {title: "Trunkrs", logo: <TrunkrsLogo width={120} height={120}/>, key: "trunkrs"},
        {title: "Cycloon", logo: <CycloonLogo width={120} height={120}/>, key: "cycloon"},
        {title: "HST", logo: <HstLogo width={120} height={120}/>, key: "hst"},
        {title: "Ampère", logo: <AmpereLogo width={120} height={120}/>, key: "ampere"},
        {title: "Zineps", logo: <ZinepsLogo width={120} height={120}/>, key: "zineps"},
        {title: "Vinologix", logo: <VinologixLogo width={120} height={120}/>, key: "vinologix"},
        {title: "WeGrow", logo: <WegrowLogo width={120} height={120}/>, key: "wegrow"},
        {title: "Anders", logo: <AltRouteOutlinedIcon sx={{fontSize:"60px"}} />, key: "other"}

    ]
    // New prop is called "Logo"
    // {title: 'normal', logo: <CheckCircleOutlineIcon />, key: "normal"},
    //     {title: 'runner', logo: <DirectionsRunIcon />, key: "runner"},
    //     {title: 'highcare', logo: <FavoriteOutlinedIcon />, key: "highcare"},
    //     {title: 'special', logo: <AutoAwesomeOutlinedIcon />, key: "special"}

    const handleOptionSelect = (option) => {
        props.handleDataUpdate({ selectedOption: columns[option].key });
        props.handleNext("tabBasicInfo");

        if(columns[option].key === "other") {
            dispatch(setProgressionInfo({maxSteps:5}));
        }else {
            dispatch(setProgressionInfo({maxSteps:6}));
        }
    };

    return (
        <SelectGroup 
            selected={-1} 
            setSelected={handleOptionSelect} 
            options={columns} 
            image={true} 
            sx={{
               display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "16px",
                gridAutoRows: "auto",
                "@media screen and (max-width: 47.9375em)" : {
                    gridTemplateColumns: "repeat(2, 1fr)",

                },
                option: {
                    flexDirection:"row",
                    alignItems:"center",
                    gap:2,
                    width:1,
                }
            }}
        />
    );
};

const ChooseShipperType = (props) => {
    return (
        <ProgressionTab 
            tabId="tabChooseType" 
            step={1} 
            maxSteps={6}

            sx={{
                body: {
                    maxHeight:550,
                }
            }}
        >
            <Content/>
        </ProgressionTab>
    )
}

export default ChooseShipperType;

